import { render } from "./AnnouncementEdit.vue?vue&type=template&id=85490fea&ts=true"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=ts"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__